interface LogoProps {
  /**
   * Accessible name. Pass an empty string where the crest sits beside the
   * league's name in text — a screen reader should not hear it twice.
   */
  title?: string;
  className?: string;
}

/**
 * The league crest.
 *
 * This is the artwork itself rather than a redrawing of it: the supplied file,
 * lifted off the white it was exported on and trimmed. It was traced by hand
 * as SVG once, which was close but not the crest — the wordmark's typeface,
 * the shield's proportions and the moustache were all approximations, and at
 * masthead size the difference showed.
 *
 * That rules out tinting it with CSS, which the vector allowed. Nothing asks
 * to: the crest carries its own palette and every theme this site has worn has
 * left it alone. `docs/brand/logo-source.webp` is the untouched original, kept
 * so a future export never has to start from a screenshot.
 *
 * The artwork is square, so one file serves the masthead, the scorebar and the
 * watermark alike; size it with `className`.
 */
export function Logo({ title = "Gentlemen's League", className }: LogoProps) {
  return (
    <img
      src="/logo.webp"
      width={961}
      height={960}
      alt={title}
      className={className}
      // The masthead crest is the largest thing on the first screen; leaving it
      // to lazy-load would pop it in after the page had already painted.
      loading="eager"
      decoding="async"
      draggable={false}
    />
  );
}
